module.exports = __webpack_public_path__ + "static/media/bg12.ed433176.jpg";